"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.parseKey = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _replacers = {
  name: /[:=]/g,
  rename: /[:=]/g,
  defaultValue: /=/g
},
    _handleStringKey = function _handleStringKey(key, source, defaultValue) {
  var result = {};

  var _parseKey = parseKey(key),
      name = _parseKey.name,
      _parseKey$rename = _parseKey.rename,
      rename = _parseKey$rename === void 0 ? name : _parseKey$rename,
      parsedDefault = _parseKey.defaultValue,
      value = source[name];

  if (typeof value !== 'undefined') {
    result = (0, _defineProperty2["default"])({}, rename, value);
  } else if (typeof defaultValue !== 'undefined') {
    result = (0, _defineProperty2["default"])({}, rename, defaultValue);
  } else if (typeof parsedDefault !== 'undefined') {
    result = (0, _defineProperty2["default"])({}, rename, parsedDefault);
  }

  return result;
},
    _handleArray = function _handleArray(mapper, source) {
  var result = {};

  if (mapper.length) {
    mapper.forEach(function (key) {
      result = _objectSpread({}, result, {}, _handleStringKey(key, source));
    });
  } else {
    result = source; // если передан пустой массив - возвращаем весь обьект params
  }

  return result;
},
    _handleObject = function _handleObject(mapper, source) {
  var result = {};
  Object.entries(mapper).forEach(function (_ref) {
    var _ref2 = (0, _slicedToArray2["default"])(_ref, 2),
        key = _ref2[0],
        defaultValue = _ref2[1];

    result = _objectSpread({}, result, {}, _handleStringKey(key, source, defaultValue));
  });
  return result;
};

var parseKey = function parseKey(key) {
  var result = {};

  if (key) {
    key = key.replace(/ +/g, '');
    result = {
      name: key.match(/^\w+[:=]?/g),
      rename: key.match(/:\w+=?/g),
      defaultValue: key.match(/=.+$/g)
    };

    for (var _key in result) {
      if (result.hasOwnProperty(_key)) {
        var item = result[_key],
            replacer = _replacers[_key];

        if (item && item[0]) {
          result[_key] = item[0].replace(replacer, '');
        } else {
          delete result[_key];
        }
      }
    }
  }

  return result;
};
/*
    Маппер для получения нужных параметров из sourceObject'а.
    Возвращает обьект либо если ничего не найдено - пустой обьект
    Маппер принимает массив строк, строку, обьект и ф-цию.
    Если передан пустой массив или undefined - передаются все параметры из params.

    Строки можно передавать в таком виде:
        'paramName' ||
        'paramName: renameParam' ||
        'paramName = defaultValue' (ограничение этого способа - defaultValue может быть только string) ||
        'paramName: renameParam = defaultValue'

    Объект передается такого вида:
        {paramName: defaultValue}  (defaultValue - все, кроме undefined) ||
        {'paramName: renameParam': defaultValue}

    Пример использования:
        mapObject(sourceObject, 'paramName') || mapObject(sourceObject, ['paramName', 'paramName2']);
    Также, из того же файла экспортится ф-ция parseKey,
    которая парсит строку 'name: rename = defaultValue' ==> {name, rename, defaultValue)
*/


exports.parseKey = parseKey;

var _default = function _default(source, mapper) {
  var result = {};

  if (typeof mapper === 'undefined') {
    result = _objectSpread({}, source);
  } else if (typeof mapper === 'function') {
    result = _objectSpread({}, mapper(source));
  } else if (Array.isArray(mapper)) {
    result = _handleArray(mapper, source);
  } else if (typeof mapper === 'string') {
    result = _handleStringKey(mapper, source);
  } else if ((0, _typeof2["default"])(mapper) === 'object' && mapper !== null) {
    result = _handleObject(mapper, source);
  }

  return result;
};

exports["default"] = _default;